import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the GlobalProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class GlobalProvider {

  public ICNO = '';
  public HotelName = '';
  public use_timer_schedule = 0;
  constructor(public http: HttpClient) {
    console.log('Hello GlobalProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/global/global.ts